/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Heartbeat(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Heartbeat',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M3.382 2.615A.98.98 0 0 1 4.325 2c.42.01.789.272.913.654l2.319 7.105a.12.12 0 0 0 .117.083.125.125 0 0 0 .12-.079l1.434-3.899a.97.97 0 0 1 .887-.621.98.98 0 0 1 .934.557l1.193 2.6c.02.043.065.071.115.071s.095-.028.115-.071l.423-.927a.98.98 0 0 1 .898-.559H16V8.77h-1.482a.13.13 0 0 0-.115.071l-1.147 2.508a.98.98 0 0 1-.897.558.98.98 0 0 1-.898-.557L10.38 8.993a.13.13 0 0 0-.12-.071.12.12 0 0 0-.113.079l-1.61 4.377a.98.98 0 0 1-.94.622.97.97 0 0 1-.918-.653L4.346 6.196a.12.12 0 0 0-.117-.083.125.125 0 0 0-.12.078l-.981 2.593a.98.98 0 0 1-.921.614H0V7.543h1.43c.053 0 .1-.031.118-.078z","fill":"currentColor"}))
}
